module.exports = __webpack_public_path__ + "static/surroundings-3-4fbb4f01f506f310f419273cbf1940b4.jpg";